import React from 'react'

import TextField from 'presentation/shared/components/TextField'
import DocumentCard from '../DocumentCard'
import { Document } from 'domain/entities/document'

import * as S from './styles'
import { cpfMask } from 'presentation/utils/masks'

type IdentificationsProps = {
  rg?: string
  cpf?: string
  documents?: Document[]
  doctor_id: number
}

const Identifications = ({
  cpf,
  documents = [],
  rg,
  doctor_id
}: IdentificationsProps) => {
  return (
    <S.Wrapper data-testid="card-identifications">
      <S.InputsContainer>
        <TextField label="RG" value={rg} required disabled />
        <TextField label="CPF" value={cpf} mask={cpfMask} required disabled />
      </S.InputsContainer>
      <S.IdentificationContainer>
        {documents.map((document) => (
          <section key={document.document_id} style={{ marginTop: '12px' }}>
            <p>{document.type}</p>
            <DocumentCard document={document} doctor_id={doctor_id} />
          </section>
        ))}
      </S.IdentificationContainer>
    </S.Wrapper>
  )
}

export default Identifications
